import React, { useState, useEffect, useContext } from 'react'
import { withNamespaces } from 'react-i18next'
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import FormControl from '@material-ui/core/FormControl'
import i18next from 'i18next'
import IntTextField from '@controls/IntTextField';
import Button from 'react-bootstrap-button-loader'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types'
import { GetLanguage } from '@utils/language';
import { updateScheduleGenerationTemplateParameters } from '@actionsSup/approvalCentral';
import { makeStyles } from '@material-ui/core/styles';
import styles from '@styles/approvalCentral.module.css'
import Switch from '@material-ui/core/Switch'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { messagesTypes } from '@utils/constants';
import { MessageContext } from '@/MessageProvider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    titleTemplate: {
        fontSize: '20px',
        '@media (max-width: 600px)': {
            fontSize: '15px',
        }
    }
}));

function ScheduleGenerationForm(props) {

    const classes = useStyles();
    const { dispatch } = useContext(MessageContext);
    const { open, setOpen, employeeCode, startDate, endDate, load } = props;
    const [locale, setLocale] = useState('fr');
    const [firstTemplateNumber, setFirstTemplateNumber] = useState(1);
    const [lastTemplateNumber, setLastTemplateNumber] = useState(90);
    const [isSendToPortal, setIsSendToPortal] = useState(true);
    const [isPosting, setIsPosting] = useState(false);

    useEffect(() => {
        const language = GetLanguage();
        setLocale(language);        
    })

    useEffect(() => {
        resizeForm();
    }, []);

    const handleFocus = (event) => {
        event.target.setSelectionRange(0, event.target.value.length);
    }

    const onFirstTemplateNumberChange = (event) => {
        setFirstTemplateNumber(event.target.value);
    }

    const onLastTemplateNumberChange = (event) => {
        setLastTemplateNumber(event.target.value);
    }

    const onIsSendToPortal = (event) => {
        setIsSendToPortal(event.target.checked);
    }

    const resizeForm = () =>  {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const header = document.querySelector('div[data-id=headerRequest]').offsetHeight;
            const offSet = 50;

            const customHeight = height - header - titleBar - offSet;

            const element = document.querySelector('#divForm');

            if (element !== null) {
                element.style.height = `${customHeight}px`;
                element.style.overflowX = 'hidden';
            }
        }, 1000);
    }

    const validateForm = () => {
        return new Promise(resolve => {

            let error = false;
            
            if (firstTemplateNumber !== 0 && !firstTemplateNumber) {
                dispatch({ type: messagesTypes.CUSTOMERROR, payload: i18next.t('approvalCentral:message.requiredFirstTemplateNumberMsg') });
                error = true;
            } else if (lastTemplateNumber !== 0 && !lastTemplateNumber) {
                dispatch({ type: messagesTypes.CUSTOMERROR, payload: i18next.t('approvalCentral:message.requiredLastTemplateNumberMsg') });
                error = true;
            }

            resolve(!error);
        });
    }

    const handleSaveClick = async () => {

        setIsPosting(true);
        const isValid = await validateForm();
        
        if (isValid) {

            const result = await updateScheduleGenerationTemplateParameters(firstTemplateNumber, lastTemplateNumber, isSendToPortal, startDate, endDate, employeeCode);

            if (result.statusCode === 0) {
                dispatch({ type: messagesTypes.SUCCESS, payload: i18next.t('approvalCentral:message.success') });
                setIsPosting(false);
                setOpen(false);
                load();
                return;
            } else {
                dispatch({ type: messagesTypes.GENERICERROR});
                setIsPosting(false);
                return;
            }
        }
        else {
            setIsPosting(false);
        }
    }

    return (
        <Dialog fullScreen open={open} onClose={() => setOpen(false)} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={() => setOpen(false)} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {i18next.t("approvalCentral:title.templateTitle")}
                    </Typography>
                </Toolbar>
            </AppBar>
            <div id="divForm" className={styles.divForm}>
                <LocalizationProvider language={locale}>
                    <IntlProvider locale={locale}>
                        <FormControl fullWidth className={styles.divInput}>
                            <IntTextField
                                id="firstTemplateNumber"
                                label={i18next.t('approvalCentral:form.firstTemplateNumber')}
                                onFocus={handleFocus}
                                handleChange={onFirstTemplateNumberChange}
                                value={firstTemplateNumber || 0}
                                className={'required'}
                                min={0}
                                max={99}
                            />
                        </FormControl>

                        <FormControl fullWidth className={styles.divInput}>
                            <IntTextField
                                id="lastTemplateNumber"
                                label={i18next.t('approvalCentral:form.lastTemplateNumber')}
                                onFocus={handleFocus}
                                handleChange={onLastTemplateNumberChange}
                                value={lastTemplateNumber || 0}
                                className={'required'}
                                min={0}
                                max={99}
                            />
                        </FormControl>

                        <FormControl fullWidth className={styles.switchComponent}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isSendToPortal}
                                        onChange={onIsSendToPortal}
                                        name="isSendToPortal"
                                        variant="success"
                                    />
                                }
                                label={i18next.t("approvalCentral:form.sendToPortal")}
                                labelPlacement="start"
                            />
                        </FormControl>
                    </IntlProvider>
                </LocalizationProvider>

                <FormControl fullWidth className={styles.divSaveButtonRequest}>
                    <Button
                        loading={isPosting}
                        className="saveButton"
                        onClick={handleSaveClick}
                        variant="success"
                    >
                        {i18next.t('approvalCentral:button.save')}
                    </Button>
                </FormControl>
            </div>          
        </Dialog>
    )
}

export default withNamespaces(['approvalCentral'], { wait: true })(ScheduleGenerationForm);

ScheduleGenerationForm.propTypes = {
    startDate: PropTypes.string.isRequired
}